import { makeAutoObservable } from 'mobx'
import { isArray } from "reusable/utils/array-utils"
import { GapAutocompleteMultipleProps } from './GapAutocompleteMultiple'
import { GapAutocompleteOptionExtended } from '../types/GapAutocompleteTypes'
import { gapAutocompleteNormaliseOptions } from '../shared/GapAutocompleteShared'
import { notNull } from '@gap/utils/utils'

interface GapAutocompleteMultipleStoreProps extends Pick<GapAutocompleteMultipleProps, 'options' | 'value' | 'onChange' | 'onNewOption'> { }

export class GapAutocompleteMultipleStore {
   sp

   constructor(sp: GapAutocompleteMultipleStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get selectedOptions() {
      return this.findOptionsById(this.sp.value)
   }

   onChange = (_: React.SyntheticEvent<Element, Event>, values: (string | GapAutocompleteOptionExtended)[] | null, reason: string) => {
      if (isArray(values)) {
         const selectedOptions = values as GapAutocompleteOptionExtended[]
         if (selectedOptions.length === 0) {
            this.sp.onChange?.([])
            return
         }
         const selectedOptionIds: string[] = selectedOptions.length ? selectedOptions.map(option => option.id) : []
         if (selectedOptionIds.length > (this.sp.value?.length || 0) && selectedOptions[selectedOptions.length - 1].inputValue) {
            this.sp.onNewOption?.([notNull(selectedOptions[selectedOptions.length - 1].inputValue)])
         } else {
            this.sp.onChange?.(selectedOptionIds)
         }
      } else {
         this.sp.onChange?.([])
      }
   }

   getOptionLabel = (option: string | GapAutocompleteOptionExtended): string => {
      if (typeof option === 'string') {
         return option
      }

      if (option.inputValue) {
         return option.inputValue
      }

      return option.label
   }

   findOptionsById = (id?: string[]): GapAutocompleteOptionExtended[] | undefined => {
      if (!id) {
         return []
      }
      return gapAutocompleteNormaliseOptions(this.sp.options).filter(option => id.includes(option.id))
   }
}
